import React from 'react';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import { tokens } from '../../../../theme';

const ConfirmAllDialog = ({
  open,
  onClose,
  colors,
  confirmDialogReleaseType,
  confirmSummary,
  confirmingAll,
  confirmProgress,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Confirm All Selected {confirmDialogReleaseType || ''} Versions
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" sx={{ color: colors.grey[200] }}>
            {confirmSummary.hasStale
              ? 'Some selected versions are older than 30 days. Review them before force confirming.'
              : 'All selected versions are 30 days old or newer. Ready to confirm all selected versions.'}
          </Typography>

          <Box display="flex" gap={1} flexWrap="wrap">
            <Chip size="small" label={`Selected pending: ${confirmSummary.total}`} />
            <Chip size="small" label={`Fresh (<=30d): ${confirmSummary.freshItems.length}`} />
            <Chip size="small" label={`Older (>30d): ${confirmSummary.staleItems.length}`} />
          </Box>

          {confirmingAll ? (
            <Box>
              <Box display="flex" justifyContent="space-between" mb={0.5}>
                <Typography variant="caption" sx={{ color: colors.grey[200] }}>
                  Confirming selected versions
                </Typography>
                <Typography variant="caption" sx={{ color: colors.grey[200] }}>
                  {confirmProgress}%
                </Typography>
              </Box>
              <LinearProgress variant="determinate" value={confirmProgress} />
            </Box>
          ) : null}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          disabled={confirmingAll}
          onClick={onClose}
          variant="contained"
          sx={{
            fontWeight: 700,
            backgroundColor: '#ffffff',
            color: colors.redAccent[500],
            border: `2px solid ${colors.redAccent[500]}`,
            '&:hover': {
              backgroundColor: colors.redAccent[900],
              color: '#ffffff',
              borderColor: colors.redAccent[400],
            },
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={confirmingAll || confirmSummary.total === 0}
          onClick={onConfirm}
        >
          {confirmSummary.hasStale ? 'Force Confirm Selected' : 'Confirm Selected'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmAllDialog;